import axiosClient from "../axiosClient";
import { cachedRequest } from "../../utils/apiCache";
export function getAllPodcastsSlider(data) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;
  let path = window.location.pathname;
  if (path === "/" || path === "/home") {
    return cachedRequest(
      `podcasts:home-slider:${JSON.stringify(data || {})}`,
      () => axiosClient.post("/home/podcasts/slider", JSON.stringify(data)),
    );
  } else {
    return cachedRequest(`podcasts:slider:${JSON.stringify(data || {})}`, () =>
      axiosClient.post("/podcasts/slider", JSON.stringify(data)),
    );
  }
}
export function getAllPodcasts(data, options = {}) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  if (bearerTokenHeader) {
    axiosClient.defaults.headers.common["Authorization"] =
      `Bearer ${bearerTokenHeader}`;
  }
  // axiosClient.defaults.headers.common['Authorization'] = `Bearer ${bearerTokenHeader}`;
  let path = window.location.pathname;
  const request = () =>
    path === "/" || path === "/home"
      ? axiosClient.post("/home/podcasts/all", JSON.stringify(data))
      : axiosClient.post("/podcasts/all", JSON.stringify(data));

  if (options.useCache === false) return request();

  if (path === "/" || path === "/home") {
    //Is the user on the Home page?
    return cachedRequest(
      `podcasts:home-all:${JSON.stringify(data || {})}`,
      request,
      { force: options.force === true },
    ); ///home/podcasts/all
  }
  return cachedRequest(`podcasts:all:${JSON.stringify(data || {})}`, request, {
    force: options.force === true,
  });
}

export function getSinglePodcast(data) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;
  return axiosClient.post("/podcasts/more", JSON.stringify(data));
}
export function podcastViewed(id, options = {}) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;
  const request = () => axiosClient.get(`/podcasts/view/${id}`);
  if (options.useCache === false) return request();
  return cachedRequest(`podcasts:view:${id}`, request, {
    ttl: options.ttl,
    persist: false,
  });
}
